export { default } from './ActivityDetailsMap';
